import {
  getOperationRuleListQueryKey,
  operationRuleCreate,
  operationRuleDeleteForProperty,
  operationRuleList,
  useOperationRuleCreate,
  useOperationRuleDeleteForProperty,
  useOperationRuleList,
  useOperationRuleListSuspense,
} from "@/api/generated/endpoints/api"
import { operationRuleCreateBody } from "@/api/generated/schemas/api.zod"

export * as OperationRuleModels from "./models"
export * from "./models"

export const operationRuleApi = {
  // Query Hooks
  useOperationRuleList,
  useOperationRuleListSuspense,

  // Query Keys
  getOperationRuleListQueryKey,

  // Raw API functions
  operationRuleList,
  operationRuleCreate,
  operationRuleDeleteForProperty,

  // Mutation Hooks
  useOperationRuleCreate,
  useOperationRuleDeleteForProperty,
}

export const operationRuleSchemas = {
  operationRuleCreateBody,
}
